/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';
import './animation047.less';

interface IAnimation047Props {
  columns: any[];
  data: any[];
  className?: string | null;
}

const Animation047: React.FunctionComponent<IAnimation047Props> = ({
  columns,
  data,
  className,
}) => {
  const getImg = (img: string) =>
    require(`../../../../../assets/${img}`).default;
  return (
    <>
      <div className={`component animation047 Desktop ${className}`}>
        <div className="animation047-title">
          {columns.map((x, idx) => (
            <div className={`subtitle subtitle${idx}`}>
              <img
                className="subtitle-icon"
                key={`icon${idx}`}
                src={getImg(x.icon)}
                alt=""
              />
              <div className="subtitle-content" key={`title${idx}`}>
                {x.title}
              </div>
            </div>
          ))}
        </div>

        <div className="animation047-content">
          {data.map((x, index) => (
            <div
              key={`content${index}`}
              className={`animation047-item animation047-item${index}`}
            >
              {columns.map((col, colIndex) => (
                <div className="sub-item" key={`${index}-${colIndex}`}>
                  {colIndex === 0 ? (
                    x[col.key]
                  ) : colIndex === 1 ? (
                    <ul>
                      {x.detail.map((itm: any, idx: any) => (
                        <li key={idx}>{itm}</li>
                      ))}
                    </ul>
                  ) : (
                    <ul>
                      {x.source.map((itm: any, idx: any) => (
                        <li key={idx}>{itm}</li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
      <div className={`component animation047 Mobile ${className}`}>
        <div className="animation047-title">
          {columns.map((x, idx) => (
            <div className={`subtitle subtitle${idx} `}>
              <img
                className="subtitle-icon"
                key={`icon${idx}`}
                src={getImg(x.icon)}
                alt=""
              />
            </div>
          ))}
        </div>
        <div className="animation047-content">
          {data.map((x, index) => (
            <div
              key={`content${index}`}
              className={`animation047-item animation047-item${index}`}
            >
              <div className="animation047-title">
                {columns.map((col, idx) => (
                  <div className={`subtitle subtitle${idx} `}>
                    <div className="subtitle-content" key={`title${idx}`}>
                      {col.title}
                    </div>
                  </div>
                ))}
              </div>
              <div className="animation047-item-content">
                <div className="sub-item-container">
                  <div className="sub-item" key={`${index}0`}>
                    <div className="sub-item-type">{x[columns[0].key]}</div>
                  </div>

                  <div className="sub-item" key={`${index}1}`}>
                    <div className="detail">
                      {columns[1].title}:
                      <ul>
                        {x.detail.map((itm: any, idx: any) => (
                          <li key={idx}>{itm}</li>
                        ))}
                      </ul>
                    </div>
                    <div className="source">
                      {columns[2].title}:
                      <ul>
                        {x.source.map((itm: any, idx: any) => (
                          <li key={idx}>{itm}</li>
                        ))}
                      </ul>
                    </div>
                    <div />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Animation047;
